const KEY = "blackdoor_registered_users_v1";

export type SocialLinks = {
  x?:         string;
  instagram?: string;
  youtube?:   string;
  telegram?:  string;
  tiktok?:    string;
};

export type RegisteredUser = {
  id:           string;
  name:         string;
  email:        string;
  avatar?:      string;
  provider:     "google" | "apple" | "email" | "wallet" | "telegram";
  registeredAt: number;
  lastSeenAt:   number;
  isPublic?:    boolean;
  socialLinks?: SocialLinks;
};

function load(): RegisteredUser[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

function save(users: RegisteredUser[]): void {
  localStorage.setItem(KEY, JSON.stringify(users));
}

export function getRegisteredUsers(): RegisteredUser[] {
  return load();
}

export function upsertRegisteredUser(user: Omit<RegisteredUser, "registeredAt" | "lastSeenAt"> & Partial<Pick<RegisteredUser, "registeredAt" | "lastSeenAt">>): void {
  const users = load();
  const now   = Date.now();
  const idx   = users.findIndex(u => u.id === user.id || u.email === user.email);
  if (idx >= 0) {
    users[idx] = { ...users[idx], ...user, lastSeenAt: now };
  } else {
    users.push({ registeredAt: now, lastSeenAt: now, ...user });
  }
  save(users);
  // persist to shared Redis store (fire-and-forget)
  if (typeof window !== "undefined") {
    fetch("/api/users", {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify(user),
    }).catch(() => {});
  }
}
